import { render, staticRenderFns } from "./NavPopoverGroup.vue?vue&type=template&id=44a15cf2&"
import script from "./NavPopoverGroup.vue?vue&type=script&lang=ts&"
export * from "./NavPopoverGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports